import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router)

export default new Router({
    mode: 'history',  // 改为 hash 模式，支持 file:// 协议直接打开
    routes: [{
        path: '/Login',
        component: resolve => require(['@/page/Login.vue'], resolve),
    }, {
        path: '/',
        component: resolve => require(['@/page/index.vue'], resolve),
    },

        {
            path: '/index',
            component: resolve => require(['@/page/index.vue'], resolve),
            // redirect: '/mini_app/manage_banner',
            redirect: '/home/systemMsg',

            children: [
                // 排名
                {
                    path: '/rank/list',
                    component: resolve => require(['@/page/rank/list.vue'], resolve)
                },
                {
                    path: '/pack/list',
                    component: resolve => require(['@/page/game/activity/pack.vue'], resolve)
                },
                // 首页
                {
                    path: '/banner/list',
                    component: resolve => require(['@/page/index/banner/list.vue'], resolve)
                },
                {
                    path: '/banner/edit',
                    component: resolve => require(['@/page/index/banner/edit.vue'], resolve)
                },
                {
                    path: '/protocol/index',
                    component: resolve => require(['@/page/index/protocol/index.vue'], resolve)
                },
                {
                    path: '/activity/index',
                    component: resolve => require(['@/page/game/activity/index.vue'], resolve)
                },
                {
                    path: '/activity/edit',
                    component: resolve => require(['@/page/game/activity/edit.vue'], resolve)
                },
                {
                    path: '/protocol/free',
                    component: resolve => require(['@/page/index/protocol/free.vue'], resolve)
                },

                // 题库
                {
                    path: '/subject/list',
                    component: resolve => require(['@/page/subject/list.vue'], resolve)
                },
                {
                    path: '/subject/edit',
                    component: resolve => require(['@/page/subject/edit.vue'], resolve)
                },
                {
                    path: '/chapter/list',
                    component: resolve => require(['@/page/chapter/list.vue'], resolve)
                },
                {
                    path: '/chapter/edit',
                    component: resolve => require(['@/page/chapter/edit.vue'], resolve)
                },
                {
                    path: '/knowledge/list',
                    component: resolve => require(['@/page/knowledge/list.vue'], resolve)
                },
                {
                    path: '/knowledge/edit',
                    component: resolve => require(['@/page/knowledge/edit.vue'], resolve)
                },
                {
                    path: '/questions/list',
                    component: resolve => require(['@/page/questions/list.vue'], resolve)
                },
                {
                    path: '/questions/edit',
                    component: resolve => require(['@/page/questions/edit.vue'], resolve)
                },
                {
                    path: '/pastExam/list',
                    component: resolve => require(['@/page/pastExam/list.vue'], resolve)
                },
                {
                    path: '/pastExam/edit',
                    component: resolve => require(['@/page/pastExam/edit.vue'], resolve)
                },
                {
                    path: '/cardGroup/list',
                    component: resolve => require(['@/page/cardGroup/list.vue'], resolve)
                },
                {
                    path: '/cardGroup/edit',
                    component: resolve => require(['@/page/cardGroup/edit.vue'], resolve)
                },
                {
                    path: '/cardGroup/children/list',
                    component: resolve => require(['@/page/cardGroup/children.vue'], resolve)
                },
                {
                    path: '/cardGroup/children/edit',
                    component: resolve => require(['@/page/cardGroup/childrenEdit.vue'], resolve)
                },
                {
                    path: '/cardbase/list',
                    component: resolve => require(['@/page/cardGroup/cardbase.vue'], resolve)
                },
                {
                    path: '/cardbase/edit',
                    component: resolve => require(['@/page/cardGroup/cardbaseEdit.vue'], resolve)
                },
                {
                    path: '/usr/list',
                    component: resolve => require(['@/page/usr/user/list.vue'], resolve)
                },
                {
                    path: '/usr/detail',
                    component: resolve => require(['@/page/usr/user/detail.vue'], resolve)
                },
                {
                    path: '/usr/plan_list',
                    component: resolve => require(['@/page/usr/plan/list.vue'], resolve)
                },
                {
                    path: '/usr/plan_detail',
                    component: resolve => require(['@/page/usr/plan/detail.vue'], resolve)
                },


                // 乐谱音频管理
                {
                    path: '/music_audio/audio',
                    component: resolve => require(['@/page/music_audio/audio.vue'], resolve)
                },
                // 添加/修改乐谱音频
                {
                    path: '/music_audio/add_audio',
                    component: resolve => require(['@/page/music_audio/add_audio.vue'], resolve)
                },
                // 乐谱分类管理
                {
                    path: '/music_audio/category',
                    component: resolve => require(['@/page/music_audio/category.vue'], resolve)
                },
                // 添加/修改乐谱分类
                {
                    path: '/music_audio/add_category',
                    component: resolve => require(['@/page/music_audio/add_category.vue'], resolve)
                },
                // 视频管理
                {
                    path: '/video_manage/video',
                    component: resolve => require(['@/page/video_manage/video.vue'], resolve)
                },
                // 照片管理
                {
                    path: '/photo_manage/photo',
                    component: resolve => require(['@/page/photo_manage/photo.vue'], resolve)
                },
                // 用户列表
                {
                    path: '/user/user',
                    component: resolve => require(['@/page/user/user.vue'], resolve)
                },{
                    path: '/user/user_detail',
                    component: resolve => require(['@/page/user/user_detail.vue'], resolve)
                },
                // 隐私协议
                {
                    path: '/home/systemMsg',
                    component: resolve => require(['@/page/home/systemMsg.vue'], resolve)
                },


                // 活动管理
                {
                    path: '/activity_new/index',
                    component: resolve => require(['@/page/activity/activity_manage.vue'], resolve)
                },
                {
                    path: '/activity/add_activity',
                    component: resolve => require(['@/page/activity/add_activity.vue'], resolve)
                },

                //商品列表nav1
                {
                    path: '/nav1/add_goods_type',
                    component: resolve => require(['@/page/nav1/add_goods_type.vue'], resolve)
                },
                // 直播商品列表
                {
                    path: '/nav1/live_product_list',
                    component: resolve => require(['@/page/nav1/live_product_list.vue'], resolve)
                },
                {
                    path: '/nav1/goods_type',
                    component: resolve => require(['@/page/nav1/goods_type.vue'], resolve)
                },
                {
                    path: '/nav1/add_goods_classify',
                    component: resolve => require(['@/page/nav1/add_goods_classify.vue'], resolve)
                },
                {
                    path: '/nav1/goods_classify',
                    component: resolve => require(['@/page/nav1/goods_classify.vue'], resolve)
                },
                {
                    path: '/nav1/comment_detail',
                    component: resolve => require(['@/page/nav1/comment_detail.vue'], resolve)
                },
                {
                    path: '/nav1/comment_list',
                    component: resolve => require(['@/page/nav1/comment_list.vue'], resolve)
                },
                {
                    path: '/nav1/shop_list',
                    component: resolve => require(['@/page/nav1/shop_list.vue'], resolve)
                },
                {
                    path: '/nav1/shop_grouping',
                    component: resolve => require(['@/page/nav1/shop_grouping.vue'], resolve)
                },
                {
                    path: '/nav1/add_shop',
                    component: resolve => require(['@/page/nav1/add_shop.vue'], resolve)
                },
                {
                    path: '/nav1/add_grouping',
                    component: resolve => require(['@/page/nav1/add_grouping.vue'], resolve)
                },
                {
                    path: '/nav1/edit',
                    component: resolve => require(['@/page/nav1/edit.vue'], resolve)
                },
                //nav2
                {
                    path: '/nav2/invitation_list',
                    component: resolve => require(['@/page/nav2/invitation_list.vue'], resolve)
                },

                {
                    path: '/nav2/wx_user_list',
                    component: resolve => require(['@/page/nav2/wx_user_list.vue'], resolve)
                },
                // {
                //   path: '/nav2/invitation_set',
                //   component: resolve => require(['@/page/nav2/invitation_set.vue'], resolve)
                // },
                // {
                //   path: '/nav2/put_forward',
                //   component: resolve => require(['@/page/nav2/put_forward.vue'], resolve)
                // },
                // 商品订单 nav3
                {
                    path: '/nav3/order',
                    component: resolve => require(['@/page/nav3/order.vue'], resolve)
                },
                {
                    path: '/nav3/batch',
                    component: resolve => require(['@/page/nav3/batch.vue'], resolve)
                },
                {
                    path: '/nav3/order_detail',
                    component: resolve => require(['@/page/nav3/order_detail.vue'], resolve)
                },
                {
                    path: '/nav3/return_goods',
                    component: resolve => require(['@/page/nav3/return_goods.vue'], resolve)
                },
                {
                    path: '/nav3/order_returned_detail',
                    component: resolve => require(['@/page/nav3/order_returned_detail.vue'], resolve)
                },
                {
                    path: '/settings/settings',
                    component: resolve => require(['@/page/settings/settings.vue'], resolve)
                },

                //系统
                {
                    path: '/set_up/role_list',
                    component: resolve => require(['@/page/set_up/role_list.vue'], resolve)
                }, // 系统角色 - 系统
                {
                    path: '/set_up/add_role',
                    component: resolve => require(['@/page/set_up/add_role.vue'], resolve)
                }, // 添加角色-系统角色 - 系统
                {
                    path: '/set_up/menu_list',
                    component: resolve => require(['@/page/set_up/menu_list.vue'], resolve)
                }, // 系统菜单 - 系统
                {
                    path: '/set_up/add_menu',
                    component: resolve => require(['@/page/set_up/add_menu.vue'], resolve)
                }, // 添加菜单-系统菜单 - 系统
                {
                    path: '/set_up/user_list',
                    component: resolve => require(['@/page/set_up/user_list.vue'], resolve)
                }, // 添加菜单-系统菜单 - 系统
                {
                    path: '/set_up/addStaff',
                    component: resolve => require(['@/page/set_up/addStaff.vue'], resolve)
                }, // 添加菜单-系统菜单 - 系统
                {
                    path: '/set_up/recommend_list',
                    component: resolve => require(['@/page/set_up/recommend_list.vue'], resolve)
                }, //推荐管理
                {
                    path: '/set_up/add_recommend',
                    component: resolve => require(['@/page/set_up/add_recommend.vue'], resolve)
                }, //推荐管理添加

                // nfc
                {
                    path: '/nfc/product_list',
                    component: resolve => require(['@/page/nfc/product_list.vue'], resolve)
                }, //nfc 产品管理
                {
                    path: '/nfc/product_add',
                    component: resolve => require(['@/page/nfc/product_add.vue'], resolve)
                }, //添加产品
                {
                    path: '/nfc/link',
                    component: resolve => require(['@/page/nfc/link.vue'], resolve)
                }, //nfc 生成nfc链接
                {
                    path: '/nfc/link_detail',
                    component: resolve => require(['@/page/nfc/link_detail.vue'], resolve)
                }, //nfc 生成nfc链接详情
                {
                    path: '/nfc/link_manage',
                    component: resolve => require(['@/page/nfc/link_manage.vue'], resolve)
                }, //nfc nfc链接管理
                {
                    path: '/nfc/mapping',
                    component: resolve => require(['@/page/nfc/mapping.vue'], resolve)
                }, //
                //通胜
                {
                    path: '/tongsheng/daily_trading',
                    component: resolve => require(['@/page/tongsheng/daily_trading.vue'], resolve)
                }, //  每日通贩
                {
                    path: '/tongsheng/solar_terms',
                    component: resolve => require(['@/page/tongsheng/solar_terms.vue'], resolve)
                }, //  二十四节气
                {
                    path: '/tongsheng/daily_icon',
                    component: resolve => require(['@/page/tongsheng/daily_icon.vue'], resolve)
                },
                {
                    path: '/tongsheng/xiu',
                    component: resolve => require(['@/page/tongsheng/xiu.vue'], resolve)
                }, //  28星宿
                {
                    path: '/tongsheng/filed',
                    component: resolve => require(['@/page/tongsheng/filed.vue'], resolve)
                }, //
                {
                    path: '/tongsheng/saying_manage',
                    component: resolve => require(['@/page/tongsheng/saying_manage.vue'], resolve)
                }, //  名言管理
                {
                    path: '/tongsheng/zodaic_manage',
                    component: resolve => require(['@/page/tongsheng/zodaic_manage.vue'], resolve)
                }, //  生肖管理
                {
                    path: '/tongsheng/zodaic_manage_edit',
                    component: resolve => require(['@/page/tongsheng/zodaic_manage_edit.vue'], resolve)
                }, //  生肖管理 修改
                {
                    path: '/tongsheng/daily_fortune',
                    component: resolve => require(['@/page/tongsheng/daily_fortune.vue'], resolve)
                }, //  每日运势
                {
                    path: '/tongsheng/avoid_incidents',
                    component: resolve => require(['@/page/tongsheng/avoid_incidents.vue'], resolve)
                }, //  宜忌事件

                {
                    path: '/copywriting/field',
                    component: resolve => require(['@/page/copywriting/field.vue'], resolve)
                }, //  7个领域
                {
                    path: '/copywriting/duty_week',
                    component: resolve => require(['@/page/copywriting/duty_week.vue'], resolve)
                },
                {
                    path: '/copywriting/zodiac',
                    component: resolve => require(['@/page/copywriting/zodiac.vue'], resolve)
                },
                {
                    path: '/copywriting/xiu',
                    component: resolve => require(['@/page/copywriting/xiu.vue'], resolve)
                },
                {
                    path: '/copywriting/lucky_color',
                    component: resolve => require(['@/page/copywriting/lucky_color.vue'], resolve)
                },
                {
                    path: '/copywriting/direction',
                    component: resolve => require(['@/page/copywriting/direction.vue'], resolve)
                },


            ]
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }
})



// WEBPACK FOOTER //
// ./src/router/index.js